import { ReactNode } from 'react';
import styled from 'styled-components';

import { useCopyToClipboard } from '../../common/hooks/useCopyToClipboard';
import { IconClipboardText } from '../../common/icons/cdl/ClipboardText';
import { Box } from '../../common/ui/Box';

const CopyButton = styled.button`
    padding: 0;
    overflow: hidden;

    svg {
        transition: opacity 75ms ease-in-out;
        opacity: 0;
    }

    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

type Size = 'default' | 'small';

const determineSize = (size: Size) => {
    switch (size) {
        case 'small':
            return '12px';
        case 'default':
            return '16px';
    }
};

const determineGridTemplateColumns = (size: Size) => {
    switch (size) {
        case 'small':
            return 'auto 12px';
        case 'default':
            return 'auto 16px';
    }
};

interface HoverableCopyToClipboardButtonProps {
    copyValue: string;
    children: ReactNode;
    size?: Size;
    color?: string;
}

export const HoverableCopyToClipboardButton = ({
    color,
    copyValue,
    children,
    size = 'default',
}: HoverableCopyToClipboardButtonProps) => {
    const copyToClipboard = useCopyToClipboard();
    return (
        <CopyButton onClick={() => copyToClipboard(copyValue)}>
            <Box
                display="grid"
                gap={2}
                alignItems="center"
                justifyContent="start"
                gridTemplateColumns={determineGridTemplateColumns(size)}
                color={color || 'inherit'}
            >
                {children}
                <IconClipboardText height={determineSize(size)} width={determineSize(size)} />
            </Box>
        </CopyButton>
    );
};
